var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmCheckGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#60646c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.5 10c0-4.14214-3.3579-7.5-7.5-7.5-4.14214 0-7.5 3.35786-7.5 7.5 0 4.1421 3.35786 7.5 7.5 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 14.5827 2.0835 2.0834 3.75-3.7501"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.4165 5.83398v4.50002l-3.33333 1.3333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmCheckGrey);
export default __webpack_public_path__ + "static/media/alarm_check_grey.7c61e28f5274f345d702f11900c62247.svg";
export { ForwardRef as ReactComponent };